import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import { APPOINTMENTS } from '../../../data/reducer';
import ClinicOptions from './ClinicOptions';
import ReservationCalendarPage from './ReservationCalendarPage';
import Alert from '../../Alert';
import { withPageBase } from '../../PageBase';
import { selectReason } from '../../../data/appointment/actions';

const { id: module_id } = module;

const isClinicToJumpOverOptionSelection = (clinicKey) => {
  return (
    clinicKey === 'appointment.reservation.UNI' ||
    clinicKey === 'appointment.reservation.VMPKS' ||
    clinicKey === 'appointment.reservation.VKPKS' ||
    clinicKey === 'appointment.reservation.VKPKO'
  );
};

function ReserveNewAppointmentPage(props) {
  let { selectedClinicKey, selectedReasonKey, history, data, setSelectReason } =
    props;

  const filteredData = data.filter((item) => item.key === selectedClinicKey);

  // Option selection should be jumped over for some clinics when there is only one option
  if (
    filteredData !== undefined &&
    filteredData[0] !== undefined &&
    filteredData[0].options.length === 1 &&
    isClinicToJumpOverOptionSelection(selectedClinicKey) &&
    isEmpty(selectedReasonKey)
  ) {
    selectedReasonKey = filteredData[0].options[0].value;
  }
  useEffect(() => {
    setSelectReason(selectedReasonKey);
  }, []);

  if (isEmpty(selectedClinicKey) && isEmpty(selectedReasonKey)) {
    history.push('/appointments');
  }
  if (!isEmpty(selectedClinicKey) && isEmpty(selectedReasonKey)) {
    return <ClinicOptions />;
  }
  if (!isEmpty(selectedClinicKey) && !isEmpty(selectedReasonKey)) {
    return <ReservationCalendarPage />;
  }

  return (
    <div>
      <Alert message={'a'} />
    </div>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    setSelectReason: (selectedReasonKey, dueDate) =>
      dispatch(selectReason(selectedReasonKey, dueDate)),
  };
};

const mapStateToProps = (state) => {
  let { isFetching, data, error, selectedClinicKey, selectedReasonKey } =
    state[APPOINTMENTS].reservation.clinics;
  return {
    isFetching,
    data,
    error,
    selectedClinicKey,
    selectedReasonKey,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReserveNewAppointmentPage);
